module.exports = __webpack_public_path__ + "img/organizations-icon.99ca8921.svg";